export const USER_INFO_RETRIEVE_START = 'USER_INFO_RETRIEVE_START';
export const USER_INFO_RETRIEVE_SUCCESS = 'USER_INFO_RETRIEVE_SUCCESS';
export const USER_INFO_RETRIEVE_FAILED = 'USER_INFO_RETRIEVE_FAILED';

export const USER_INFO_REGISTER_START = 'USER_INFO_REGISTER_START';
export const USER_INFO_REGISTER_SUCCESS = 'USER_INFO_REGISTER_SUCCESS';
export const USER_INFO_REGISTER_FAILED = 'USER_INFO_REGISTER_FAILED';

export const USER_INFO_UPDATE_START = 'USER_INFO_UPDATE_START';
export const USER_INFO_UPDATE_SUCCESS = 'USER_INFO_UPDATE_SUCCESS';
export const USER_INFO_UPDATE_FAILED = 'USER_INFO_UPDATE_FAILED';


export interface UserInfoRequest {
  profileId: string;
  userRef: string;
  organizationCode: string;
  agentId?: string;
  agencyCode?: string;
  sellerCode?: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  status?: string;
  role: string;
  preferredLang: string;
  provinceLicense: string[];
}

interface Profile {
  rootOrganizationCode: string;
}

export interface UserInfoStore {
  retrieveLoading?: boolean;
  submitLoading?: boolean;
  formData?: UserInfoRequest;
  data?: UserInfoRequest;
  retrieveError?: unknown;
  submitError?: unknown;
  profile?: Profile;
}

export type AgentSearchFilter = {
  firstName?: string;
  lastName?: string;
  email?: string;
  profileCode?: string;
  status?: string;
  title?: string;
  role?: string;
  organization?: string;
};

export interface ApiError {
  statusCode: number;
  message: string;
}